import React, { Component } from "react";

class About extends Component {
    render(){
        return(
            <p>hello, about</p>
        )
    }
}

export default About;